import { useCallback, useState } from "react";

export type Theme = "light" | "dark";

function current(): Theme {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(current);
  const setTheme = useCallback((next: Theme) => {
    document.documentElement.classList.toggle("dark", next === "dark");
    try {
      localStorage.setItem("ta-theme-v2", next);
    } catch {
      /* depolama kapalı olabilir */
    }
    setThemeState(next);
  }, []);
  return { theme, toggle: () => setTheme(theme === "dark" ? "light" : "dark") };
}
